(() => {
  'use strict';
  const root = document.querySelector('.exp-ml');
  if (!root || root.dataset.trackingReady) return;
  root.dataset.trackingReady = 'true';
  const pixelId = root.dataset.metaPixelId;
  const allowed = (purpose) => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return purpose === 'marketing'
        ? privacy?.marketingAllowed() === true
        : privacy?.analyticsProcessingAllowed() === true;
    } catch { return false; }
  };
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
  }
  const sendMeta = (payload, eventId, attempts = 0) => {
    if (!allowed('marketing')) return;
    if (typeof window.fbq === 'function') {
      window.fbq('trackSingleCustom', pixelId, 'MercadoLivreClick', payload, { eventID: eventId });
    } else if (attempts < 20) {
      // The new tab keeps this page alive while the existing pixel finishes loading.
      window.setTimeout(() => sendMeta(payload, eventId, attempts + 1), 250);
    }
  };
  const trackClick = (event) => {
    if ((event.type === 'click' && event.button !== 0) || (event.type === 'auxclick' && event.button !== 1)) return;
    const link = event.target.closest?.('a[data-ml-link]');
    if (!link || !root.contains(link)) return;
    const destination = new URL(link.href);
    if (destination.hostname !== 'www.mercadolivre.com.br' && destination.hostname !== 'mercadolivre.com.br') return;
    const payload = {
      product_line: link.dataset.productLine,
      button_position: link.dataset.buttonPosition,
      destination: destination.origin + destination.pathname,
      landing_page: root.dataset.landingPage || 'expansiv-mercado-livre',
    };
    const eventId = window.crypto?.randomUUID?.() || `ml-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    if (allowed('analytics')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'expansiv_ml_click', ...payload, event_id: eventId });
      // Custom Shopify event; no cart, checkout or purchase event is fabricated.
      try { window.Shopify?.analytics?.publish('expansiv:mercado_livre_click', payload); } catch { /* Navigation remains available. */ }
    }
    if (/^\d+$/.test(pixelId) && allowed('marketing')) sendMeta(payload, eventId);
  };
  root.addEventListener('click', trackClick);
  root.addEventListener('auxclick', trackClick);

  // Keep the original image link as the no-JavaScript fallback.
  const lightbox = root.querySelector('[data-ml-lightbox]');
  const fullImage = root.querySelector('[data-ml-full-image]');
  let zoomTrigger;
  if (lightbox && fullImage && typeof lightbox.showModal === 'function') {
    root.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[data-ml-zoom]');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      zoomTrigger = link;
      fullImage.src = link.href;
      fullImage.alt = link.querySelector('img')?.alt || 'Foto ampliada do produto';
      lightbox.showModal();
      document.body.classList.add('exp-ml-zoom-open');
    });
    lightbox.querySelector('[data-ml-close]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => {
      if (event.target !== lightbox) return;
      const bounds = lightbox.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) lightbox.close();
    });
    lightbox.addEventListener('close', () => {
      document.body.classList.remove('exp-ml-zoom-open');
      fullImage.removeAttribute('src');
      zoomTrigger?.focus({ preventScroll: true });
    });
  }

  const sticky = root.querySelector('[data-ml-sticky]');
  const heroLink = root.querySelector('[data-button-position="hero"]');
  const finalLink = root.querySelector('[data-button-position="final"]');
  if (sticky && heroLink && finalLink && 'IntersectionObserver' in window) {
    let pastHero = false;
    let atFinal = false;
    const updateSticky = () => { sticky.hidden = !pastHero || atFinal; };
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === heroLink) pastHero = entry.boundingClientRect.bottom < 0;
        if (entry.target === finalLink) atFinal = entry.isIntersecting;
      }
      updateSticky();
    });
    observer.observe(heroLink);
    observer.observe(finalLink);
  }
})();
